import _taggedTemplateLiteral from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;
var __jsx = React.createElement;
import React from 'react';
import styled from 'styled-components';
import { colorPalette } from './../../../../styles/styleGuide';
import Label from './Label';
import ErrorMessage from './ErrorMessage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
var defaultProps = {};
var Radio = function Radio(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    isValid = _ref.isValid,
    required = _ref.required,
    validationMessage = _ref.validationMessage,
    defaultChecked = _ref.defaultChecked,
    defaultValue = _ref.defaultValue,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    hasIcons = _ref.hasIcons,
    icon = _ref.icon;
  return __jsx(Container, {
    "data-id": "fieldTypes_Radio_Container"
  }, __jsx(RadioLabel, {
    "data-id": "fieldTypes_Radio_RadioLabel"
  }, __jsx(Input, {
    name: name,
    type: "radio",
    value: value,
    defaultValue: defaultValue,
    checked: defaultChecked,
    onChange: onChange,
    disabled: disabled,
    required: required,
    hasIcons: hasIcons,
    "data-id": "fieldTypes_Radio_Input"
  }), hasIcons ? __jsx(IconRadio, {
    hasIcons: hasIcons,
    "data-id": "fieldTypes_Radio_IconRadio"
  }, __jsx(FontAwesomeIcon, {
    icon: icon || 'fa-expand',
    "data-id": "fieldTypes_Radio_FontAwesomeIcon"
  }), __jsx(Label, {
    name: id,
    content: label,
    mode: "span",
    "data-id": "fieldTypes_Radio_Label"
  })) : __jsx(React.Fragment, null, __jsx(FakeRadio, {
    "data-id": "fieldTypes_Radio_FakeRadio"
  }, __jsx(BlueDot, {
    "data-id": "fieldTypes_Radio_BlueDot"
  })), __jsx(Label, {
    name: id,
    content: label,
    mode: "span",
    "data-id": "fieldTypes_Radio_Label"
  }))), validationMessage && __jsx(ErrorMessage, {
    isValid: isValid,
    message: validationMessage,
    "data-id": "fieldTypes_Radio_ErrorMessage"
  }));
};
Radio.defaultProps = defaultProps;
export default Radio;
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  position: relative;\n"])));
var RadioLabel = styled.label(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n"])));
var FakeRadio = styled.span(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-shrink: 0;\n  width: 24rem;\n  height: 24rem;\n  border-radius: 50%;\n  align-items: center;\n  justify-content: center;\n  border: solid 1rem ", ";\n  margin-right: 8rem;\n"])), colorPalette.beige);
var BlueDot = styled.span(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  background: ", ";\n  width: 10rem;\n  height: 10rem;\n  border-radius: 50%;\n"])), colorPalette.blue);
var IconRadio = styled.span(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 130rem;\n  height: 130rem;\n  padding: 4px;\n  border: solid 1rem ", ";\n  border-radius: 8rem;\n  color: ", ";\n  cursor: pointer;\n  position: relative;\n  text-align: center;\n  transition: all 0.2s ease;\n  word-wrap: break-word;\n\n  svg {\n    overflow: visible;\n    width: 50rem;\n    height: 50rem;\n    margin-bottom: 8rem;\n  }\n\n  span {\n    font-size: 16px;\n    color: ", ";\n    font-style: normal;\n  }\n\n  &:hover {\n    background: ", ";\n    border-color: ", ";\n    svg {\n      color: ", ";\n    }\n    span {\n      color: ", ";\n    }\n  }\n"])), colorPalette.orange, colorPalette.orange, colorPalette.orange, colorPalette.orange, colorPalette.white, colorPalette.white, colorPalette.white);
var Input = styled.input(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  opacity: 0;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n  \n  &:disabled {\n    ", "\n\n    ", "\n    \n    // Text\n    + span + span {\n      color: ", ";\n      text-decoration: line-through;\n    }\n  }\n"])), function (props) {
  return !props.hasIcons && "\n    + span > span {\n      display: none;\n    }\n    \n    &:checked + span > span {\n      display: flex;\n    }\n  ";
}, function (props) {
  return props.hasIcons && "\n\n    &:checked + span {\n      border-color: ".concat(colorPalette.orange, ";\n      background: ").concat(colorPalette.orange, ";\n      \n      svg {\n        color: ").concat(colorPalette.white, ";\n      }\n      \n      span {\n        color: ").concat(colorPalette.white, ";\n      }\n    }\n  ");
}, function (props) {
  return !props.hasIcons && "\n      // Circle\n      + span {\n        background: ".concat(colorPalette.background, ";\n        border: solid 1rem ").concat(colorPalette.lightBeige, ";\n      }\n    ");
}, function (props) {
  return props.hasIcons && "\n      + span {\n        background: ".concat(colorPalette.background, ";\n        border: solid 2rem ").concat(colorPalette.lightBeige, ";\n        \n        i {\n          color: ").concat(colorPalette.lightBeige, ";\n        }\n      }\n    ");
}, colorPalette.lightBeige);